// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";
import { jsonCKBTxMember } from "./types/nervosTransaction";
import { TransactionWithScriptGroups } from "./types/nervosTransactionTypes";
import { ETHPoolCall } from "./types/liquidity";

// LPDepositInitResponse is the deposit init result. CKB path returns
// unsignedTx + expectedOutpoint (owner signs then LPSubmitSigned). ETH path
// returns eth call metadata (wallet calls the LiquidityPool contract directly).
@jsonObject()
export default class LPDepositInitResponse extends PerunMessage {
  @jsonCKBTxMember() unsignedTx?: TransactionWithScriptGroups;
  @jsonMember(String, { isRequired: false }) expectedOutpoint?: string;
  @jsonMember(ETHPoolCall, { isRequired: false }) eth?: ETHPoolCall;

  constructor(
    unsignedTx?: TransactionWithScriptGroups,
    expectedOutpoint?: string,
    eth?: ETHPoolCall,
  ) {
    super();
    this.unsignedTx = unsignedTx;
    this.expectedOutpoint = expectedOutpoint;
    this.eth = eth;
  }

  messageType(): MessageType {
    return LPDepositInitResponse;
  }

  messageTypeName(): MessageTypeName {
    return "LPDepositInitResponse";
  }
}
